
















import { defineComponent, computed } from '@vue/composition-api'
import { LandlordToggle, NotificationBanner } from '@/components'
import { RouteName } from '@/router/enum' // Adjust if enum path differs
import { GrootContainer } from 'groot-components'
import { applyReactInVueWithOptions } from '@/utils/react.utils'

export default defineComponent({
  components: {
    LandlordToggle,
    NotificationBanner,
    Container: applyReactInVueWithOptions(GrootContainer)
  },
  setup (_, context) {
    const route = context.root.$route

    const showNotificationBanner = computed(() => route.name === RouteName.LandingPage ||
      route.name === RouteName.WhereDoYouLivePage
    )

    return {
      showNotificationBanner
    }
  }
})
